const cjer = {
  setCookie : function(cookieName, cookieValue, cookieMinutes) {
    var date = new Date()
    let domain = location.host.split('.').slice(-2).join('.');

    date.setTime(date.getTime() + (cookieMinutes * 60 * 1000))
    var cookie = [
      cookieName + '=' + cookieValue, 'domain=.' + domain, 'expires=' + date.toUTCString(), 'path=/'
    ]
    document.cookie = cookie.join(';');
    return undefined;
  },
  getCookie : function(cookieName){
    var cookieParam = cookieName + "="
    var cookieSplit = document.cookie.split(';')
    for (var i = 0; i < cookieSplit.length; i++) {
      var cookiePart = cookieSplit[i];
      while (cookiePart.charAt(0) == ' ') {
        cookiePart = cookiePart.substring(1)
      }
      if (cookiePart.indexOf(cookieParam) == 0) {
        return cookiePart.substring(cookieParam.length, cookiePart.length)
      }
    }
    return undefined;
  },
  queryString: location.search.substring(1).split('&').reduce(function(acc, paramRaw) {
    var param = paramRaw.split('=');
    acc[param[0]] = param[1];
    return acc;
  }, {}),
  getQueryParam: function(name) {
    if(this.queryString[name]) {
      this.setCookie(name, this.queryString[name], 525600)
      return this.queryString[name];
    };
    if(this.getCookie(name)) return this.getCookie(name);
    return false;
  },
  isTCB: function() {
    const arr = ['utm_source','utm_medium','utm_campaign','utm_content'];
    let is = this.getQueryParam('source') && arr.some((el) => {
      return this.getQueryParam(el);
    });
    return is;
  },
  utmString: function(isSkip) {
    const that = this;
    const arr = ['utm_source','utm_medium','utm_campaign','utm_content', 'source', 'subid'];
    let str = '';
    arr.forEach(function(el) {
      if(that.getQueryParam(el)) str += '&' + el +'='+ that.getQueryParam(el);
    });

    if(!this.isTCB()) {
      str += '&utm_content=gs';
    }
    
    str = str+'&skip=10&plimit=1';
    str = str.replace('&', '');
    return str;
  },
  utmObject: function() {
    const that = this;
    const arr = ['utm_source','utm_medium','utm_campaign','utm_content', 'source', 'subid'];
    let obj = {};
    arr.forEach(function(el) {
      if(that.getQueryParam(el)) obj[el] = that.getQueryParam(el);
    });
    return obj;
  },

  sendYaEvent: function (a, b) {
    if(typeof Ya == 'undefined') {
      setTimeout(sendYaEvent, 333, a, b);
      return;
    }
    for(var c in window) {
      if(c.indexOf('yaCounter')>-1) {
        var id = c.replace( /[^\d.]/g, '' );
        window['yaCounter'+id].reachGoal(a, b);
      }
    } 
  },
  sendHit: function(page) {
    if(typeof Ya == 'undefined') {
      setTimeout(this.sendHit, 333, page);
      return;
    }
    for(var c in window) {
      if(c.indexOf('yaCounter')>-1) {
        var id = c.replace( /[^\d.]/g, '' );
        window['yaCounter'+id].hit(page);
      }
    } 
  },
  getExtension: function(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0].toLowerCase() : undefined;
  }
  
}


export default cjer;